<template>
  <div
    class="flex flex-row items-center gap-2 text-sm cursor-pointer select-none text-gray-800 group/child"
    :title="item.title"
    @click="onClick(item)"
  >
    <SidebarChildIcon
      v-tooltip.right="{
        content: item.title,
        disabled: !compactMode
      }"
      :tooltip="item.title"
      :icon="item.icon"
      :compact="compactMode"
    />
    <span
      v-if="!compactMode"
      class="py-2 group-hover/child:text-primary truncate font-medium"
    >
      {{ item.title }}
    </span>
    <BookmarkControl
      v-if="!compactMode"
      class="ml-auto self-stretch"
      v-bind="{ item }"
    />
  </div>
</template>

<script setup lang="ts">
import { MenuItem } from "@q-food/q-food";
import { useAppSidebarStore } from "~/stores/AppSidebar";

defineProps<{
	item: MenuItem;
}>();
const { compactMode } = storeToRefs(useAppSidebarStore());

const { push } = useRouter();

function onClick(item: MenuItem) {
	// The item's title travels along: a custom page (one whose route is not a backend resource) has
	// no name of its own to fall back on, and this label is already translated by the backend.
	const path = "/" + item.action.replace(".", "/");

	if (Object.values(item.props).length > 0) {
		const query = new URLSearchParams(item.props).toString();
		push(`${path}?${query}`, { title: item.title });
	} else {
		push(path, { title: item.title });
	}
}
</script>

<style scoped></style>
